import { NgModule } from '@angular/core';
import { translationChunksConfig, translationsEn } from '@spartacus/assets';
import {
  I18nConfig,
  ProductPageMetaResolver,
  provideConfig,
  provideConfigFactory,
  SiteContextConfig,
} from '@spartacus/core';
import { ViewConfig, defaultCmsContentProviders } from '@spartacus/storefront';
import { environment } from '../../environments/environment';
import { Meta } from '@angular/platform-browser';
import { defaultStoreFinderLayoutConfig, layoutConfig } from './features/store-front/layout-config';
import { mediaConfig } from './features/store-front/default-media.config';
import { defaultOccProductConfig } from '../core/occ/default-occ-product-config';
import { customGlobalMessageConfig } from '../core/config/global-message-config';
import { defaultB2bOccConfig } from '../core/occ/default-b2b-occ-config';
import { defaultOccLiteratureContentConfig } from './features/product/product-list/counter-results/core/counter-results-literature.occ';
import { CustomProductPageMetaResolver } from '../core/services/custom-product-page-meta.resolver';

@NgModule({
  providers: [
    provideConfigFactory(() => ({ backend: { occ: { baseUrl: environment.baseUrl } } }), [Meta]),
    provideConfig(layoutConfig),
    provideConfig(defaultStoreFinderLayoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(<SiteContextConfig>{
      context: {
        baseSite: ['marathonb2b'],
        language: ['en'],
        currency: ['USD'],
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: translationsEn },
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
    }),
    provideConfig({
      features: {
        level: '221121.15',
      },
    }),
    provideConfig(<ViewConfig>{
      view: {
        defaultPageSize: 20,
        infiniteScroll: {
          active: false,
          productLimit: 10000,
          showMoreButton: false,
        },
      },
    }),
    provideConfig(defaultB2bOccConfig),
    provideConfig(defaultOccProductConfig),
    provideConfig(defaultOccLiteratureContentConfig),
    provideConfig(customGlobalMessageConfig),
    provideConfig({
      authentication: {
        client_id: 'mobile_android_public',
        client_secret: '',
        customLoginPage: {
          csrfEndpoint: '/csrf',
          loginFormEndpoint: '/login',
        },
      },
    }),
    {
      provide: ProductPageMetaResolver,
      useExisting: CustomProductPageMetaResolver,
    },
  ],
})
export class SpartacusConfigurationModule {}
